const positionOrder = {
    'Coach': 1,
    'Goalkeeper': 2,
    'Defender': 3,
    'Midfielder': 4,
    'Attacker': 5
};

export const sortPlayers = (players) => {
    return players.sort((a, b) => {
        // 1. Club name
        const clubNameA = a.clubName || '';
        const clubNameB = b.clubName || '';
        if (clubNameA < clubNameB) return -1;
        if (clubNameA > clubNameB) return 1;

        // 2. Position
        const posA = positionOrder[a.position] || 99;
        const posB = positionOrder[b.position] || 99;
        if (posA < posB) return -1;
        if (posA > posB) return 1;

        // 3. Player name
        const nameA = a.name || '';
        const nameB = b.name || '';
        if (nameA < nameB) return -1;
        if (nameA > nameB) return 1;

        return 0;
    });
};